export default __webpack_public_path__ + "static/media/dataEntry.89bde068.svg";